import { ADD_SNACK } from "redux/actionTypes";

export const add = msg => dispatch =>
  dispatch({ type: ADD_SNACK, payload: msg });
